module.exports = __webpack_public_path__ + "assets/images/03_active_a4cf028afaf79e2574ecaaf07d0b0449.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/03_active.png
// module id = 119
// module chunks = 0